export const EMPTY_HELPER_TEXT = "​";
export const SNACKBAR_SCREEN_TIME = 3000;
